import { Currencies } from 'src/enums';

export const CurrencySymbols = {
  [Currencies.AUD]: '$',
  [Currencies.NZD]: '$',
  [Currencies.USD]: '$',
  [Currencies.EUR]: '€',
  [Currencies.GBP]: '£',
};
